<template>
  <div>
    <label for="saveIntoLibrary" class="col-xs-3 control-label">{{
      $t('modals.save_into_library')
    }}</label>
    <div class="col-xs-9">
      <select
        class="form-control"
        id="saveIntoLibrary"
        :value="destinationLibrary"
        @input="setDestinationLibrary($event.target.value)"
      >
        <option
          v-for="lib in writableLibraries"
          v-bind:key="lib.id"
          :value="lib.id"
        >
          {{ $t(`libraries.${lib.id}`) }}
        </option>
      </select>
    </div>
  </div>
</template>

<script>
import {mapState, mapMutations} from 'vuex';

export default {
  name: 'LibrarySelector',
  computed: mapState({
    writableLibraries: state => state.libraries.filter(l => !l.readOnly),
    destinationLibrary: state => state.destinationLibrary
  }),
  methods: {
    ...mapMutations(['setDestinationLibrary'])
  },
  created: function () {
    const selected =
      this.writableLibraries && this.writableLibraries.find(l => l.active);
    if (selected !== undefined) {
      this.setDestinationLibrary(selected.id);
    }
  }
};
</script>

<style scoped></style>
